export default "__VITE_ASSET__Br73wCsw__"